// 国家列表
import { NativeModules } from 'react-native';
import { Platform } from 'react-native';
import { getPageProps, getUrlParam } from '@kibt/krn-utils';
import queryString from 'query-string';
import { getUUID, resetUUID, setCookie, getCookie } from '@kwr/utils-krn';
import { kpn, setSameDomainCookie } from './device-info';

export const kpf = kpn;
export const language = (Platform.OS === 'web' ? navigator.language : NativeModules.KSLanguage?.getLanguage()).toLowerCase();
const country = language.split('-')[0];
console.log('language', language, country);

export const lang = (() => {
    switch (country) {
        case 'zh':
            return 'zh';
        case 'es':
            return 'es';
        case 'pt':
            return 'pt-BR';
        case 'id':
            return 'id';
        case 'in':
            return 'id';
        case 'en':
        default:
            return 'en';
    }
})();

export function filterEmptyValues(obj, filterNaN?) {
    return Object?.keys(obj)?.reduce((acc, key) => {
        if (filterNaN && Number.isNaN(obj[key])) {
            return acc;
        }
        if (obj[key] !== null) {
            acc[key] = obj[key];
        }
        return acc;
    }, {});
}

/**
 * @deprecated
 * 注意由于是端外，Cookie userId 无法可读，需要从 useLoginStore 的 isLogin 取
 */
export const isLogin = getCookie('token') || (getCookie('ud') && getCookie('ud') !== '0');
export const userId = getCookie('user_id') || getCookie('userId') || getCookie('ud');
export let deviceId = getCookie('did') || '';
export const webDid = getCookie('webDid') || '';
export const setDeviceId = (d: string) => {
    // 判断 did 和 webDid 是否一致，不一致则覆盖 did
    if (webDid && deviceId !== webDid) {
        setSameDomainCookie('did', webDid);
        deviceId = webDid;
        return;
    }

    // 已存在就不设值
    if (!d) return null;
    if (deviceId && webDid) return null;

    deviceId = d;
    // 重新生产 did
    setSameDomainCookie('did', d);
    setSameDomainCookie('webDid', d);
};
export const UUID = resetUUID;
export const uuid = getUUID();

// 激励动态配置 LocalStorage name
export enum incentiveKconfConfigName {
    name = 'INCENTIVE_KCONF_CONFIG_DATA',
}
export function getRequest() {
    let url = decodeURIComponent(window.location.search);
    const theRequest: Record<string, string> = {};
    if (url.indexOf('?') !== -1) {
        url = url.substr(1);
    }
    if (url) {
        const strs = url.split('&');
        for (let i = 0; i < strs.length; i++) {
            const srtArry = strs[i].split('=');
            const y = srtArry.shift() as string;
            theRequest[y] = decodeURIComponent(srtArry.join('='));
        }
    }
    return theRequest;
}

export function getQuery(key: string): string {
    // MPA场景
    if (Platform.OS === 'web') {
        const url = new URL(window.location.href);
        const val = url.searchParams.get(key);
        if (key === 'env' && (!val || val === 'null')) {
            if (url.host.includes('staging.')) return 'staging';
            if (url.host.includes('prt.')) return 'prt';
        }
        return val;
    } else {
        return getUrlParam(key);
    }
}

export function getQuerys(): Record<string, string | undefined> {
    if (Platform.OS === 'web') {
        const queryRes = queryString.parseUrl(window.location.href);
        return queryRes.query;
    } else {
        return getPageProps();
    }
}

export const isInBrowser = Platform.OS === 'web';

export const CountryNameList = {
    BRA: ['BRA', 'BR'],
    IDN: ['IDN', 'ID'],
};

// 获取国家
const getCountry = () => {
    const curCountry = (getCookie('countryInfo') || 'UNKNOWN').toUpperCase();
    const isIdn = CountryNameList.IDN.includes(curCountry);
    const isBra = CountryNameList.BRA.includes(curCountry);
    if (isIdn) {
        console.log('curCountry', curCountry);
        return CountryNameList.IDN[0];
    } else if (isBra) {
        return CountryNameList.BRA[0];
    }
    return null;
};

// 当前国家
// 不是印尼或者巴西，默认为巴西兜底
export const currentCountry = getCountry() || 'BRA';
// 不做兜底
export const currentCountryWithoutEars = getCountry();

export const getIsIdn = () => CountryNameList.IDN.includes(currentCountry);
export const getIsBra = () => CountryNameList.BRA.includes(currentCountry);

export const CountryCurrencyList = {
    BRA: 'R$',
    IDN: 'Rp',
};

export const CountryThousandsSeparator = {
    BRA: '.',
    IDN: '.',
};

export const CountryDecimalSeparator = {
    BRA: ',',
    IDN: ',',
};

export const webCurrency = CountryCurrencyList[currentCountry] || '';

export const getThousandsSeparator = () => {
    return CountryThousandsSeparator[currentCountry] || ',';
};

export const getDecimalSeparator = () => {
    return CountryDecimalSeparator[currentCountry] || '.';
};

export const RootTagMap = {
    OrderConfirm: 1,
};

// bundleId 的常量，后续可随时补充
export const BUNDLE_ID_LIST = {
    DETAIL: 'Detail',
    EcommOrderConfirm: 'EcommOrderConfirm',
    MyShoppingCar: 'MyShoppingCar',
    EcomRecommendGoods: 'EcomRecommendGoods',
    ShoppingCar: 'ShoppingCar',
    EcomSpecPopupPage: 'EcomSpecPopupPage',
    ExpEcommMerchant: 'ExpEcommMerchant',
    EcommMerchant: 'EcommMerchant',
    EcommAddress: 'EcommAddress',
    OrderDetail: 'OrderDetail',
    EcommCommerce: 'EcommCommerce',
};

// 【重要】Scene 值，影响领券，影响订单价格
// https://docs.corp.kuaishou.com/k/home/VJzIDqh33QWs/fcABlilWQiit-QS-ktUcZiYPx
export enum SCENE {
    DEFAULT_SCENE = '0',
    PRE_SUBMIT = '1', // 报价调用，仅返回已领可用
    PRE_SUBMIT_LIST = '2', // 用户提单页点击列表调用，仅包含已领的，已领本单不可用的(包含原因)
    LIVE_CART = '3', // 直播间小黄车上方券列表，过滤规则同item, 第一张为可用(包含未领可领)运费券，后面全为商品券，按面额排序
    PRODUCT_DETAIL = '4', // 商品详情页透出, 1张可用(包含未领)运费券 + 10张可用(包含未领)商品券, 最多10张
    PRODUCT_CARD = '5', // 商品卡片透出，1张可用(包含未领)运费券 + 3张可用(包含未领)商品券
    PRODUCT_DISCOUNT_LIST = '6', // 商品详情页列表， 可用(包含未领)运费券 + 可用(包含未领)商品券， 运费券在前商品券在后，最多各10张
    LIVE_PENDANT = '7', // 直播间挂件 （所有已领 + 未领）
    LIVE_FLOATING_LAYER = '8', // 直播间浮层 （所有已领 + 未领）
    LIVE_RED_POCKET = '9', // 直播间红包弹窗（未领）
    SHOP_CART = '10', // 购物车券列表 （已领+未领）， 仅平台通用券， 1张商品券 + 1张运费券 + 3张商品券
    SHOP_CART_STORE = '11', // 购物车店铺头 平台通用券 + 可用店铺 （1张运费券（已领+未领） + 1张商品券（已领）
    SHOP_CART_SKU = '12', // 购物车分SKU券列表
    PRE_SUBMIT_CHECK_TRANSPORTATION = '13', // 提单页判断运费直降，只出可用的运费券
    SHOP_CART_DISCOUNT_LIST = '14', // 购物车券列表半屏页，10 张运费券 + 10张商品券 （已领 + 未领）
    SHOP_COUPON = '15', // 店铺页上方券列表
    SHOP_COUPON_LIST = '16', // 店铺页券列表半屏页
    KWAISHOP_COUPON_LIST = '17', // 商城页券列表
    KWAISHOP_POP_WIDGET = '18', // 商城页弹窗
    LIVE_CART_PRODUCT_CARD = '19', // 直播间小黄车商品卡片
    LIVE_CART_PRODUCT_DETAIL = '20', // 直播间小黄车商品详情
    LIVE_CART_PRODUCT_DISCOUNT_LIST = '21', // 直播间小黄车商品详情券半屏页
    SHORT_VIDEO_PRODUCT_DETAIL = '22', // 短视频商品商详页券列表
    SHORT_VIDEO_PRODUCT_DISCOUNT_LIST = '23', // 短视频商品详情券半屏页
    LIVE_CART_MAKE_UP_ORDER_PRODUCT_CARD = '24', // 直播间凑单半屏商品列表
    SHOP_MAKE_UP_ORDER = '25', // 店铺页凑单
    KWAI_SHOP_MAKE_UP_ORDER = '26', // 商城凑单
    KWAI_SHOP_SEARCH = '27', // 商城搜索
    APP_SEARCH = '28', // APP搜索
    KWAISHOP_PREHEAT = '29', // 商城预热
    SHORT_VIDEO_PLC = '30', // 短视频PLC
    SHORT_VIDEO_PRODUCT_HALF_SCREEN = '31', // 点击短视频PLC进入的半屏商品卡
    LIVE_PREVIEW_CARD = '32', // 直播间外预览卡
    SHORT_VIDEO_FEED_PRODUCT_CARD = '33', // 短视频推荐商品卡
    SHORT_VIDEO_FEED_PRODUCT_DETAIL = '34', // 短视频推荐商品详情
    SHORT_VIDEO_FEED_PRODUCT_DISCOUNT_LIST = '35', // 短视频推荐商品详情券半屏页
    LIVE_CART_PRODUCT_CARD_ADD_TO_CART = '36', // 直播间商品卡加购到购物车
    KWAISHOP_FEED_PRODUCT_CARD = '40', // 商城feed商品卡片
    SHORT_VIDEO_PRODUCT_CARD_ADD_TO_CART = '41', // 短视频商品卡加购到购物车
    UG_FREE_BUY = '42', // 激励, 1元购券
    UG_LADDER_COUPON = '43', // 激励, 阶梯领现金券
    AFTERSALE_CALLBACK = '44', // 售后挽单发券
    SHORT_VIDEO_POPUP = '45',
    MARKETING_NEW_BUYER_TASK = '46', // 新手复购任务
    ORDER_PAY_SUCCESS_COUPON_LIST = '47', // 支付成功页面券列表
    PRE_SUBMIT_SAMPLE = '48', // 选品中心提单选券
    SHOP_POP_WIDGET = '49', // 店铺页券弹窗
    SHOP_CART_POP_WIDGET = '50', // 购物车券弹窗
    PRODUCT_COMMENT_COUPON = '51', // 商品评价返优惠券
    SHOP_SEARCH_CART_POP_WIDGET = '52', // 商场搜索券弹窗

    // B端场景
    DISTRIBUTOR_PRODUCT_CARD = '101', // B端达人端 默认商品卡片
    DISTRIBUTOR_PRODUCT_DETAIL = '102', // B端达人端 默认商品详情页
    DISTRIBUTOR_COUPON_LIST = '103', // B端达人端，券列表

    // 外投场景
    PRODUCT_DETAIL_OUTSIDE_WEB = '71', // 端外商品详情页
    PRODUCT_SEARCH_OUTSIDE_WEB = '72', // 端外商品搜索页
    PRODUCT_DETAIL_POPUP_OUTSIDE_WEB = '73', // 端外券弹窗
}

export enum SEARCH_SOURCE {
    UNKNOWN = 0,
    MERKET = 1,
    DETAIL = 2,
    MERCHANT = 3,
    PUSH = 4,
}

// 统一端外为 84 Media_Source
export const MEDIA_SOURCE = 84;
